module.exports = __webpack_public_path__ + "static/media/epic.ed275679.jpg";